export class Order {

  id: number;
  date: number;
  dateFormated: string;
  dateHour: string;
  orderTypeDescription: string;
  orderTypeId: number;
  statusId: number;
  clientId: number;
  clientName: string;
  total: number;
  userName: string;
  userLatitude: string;
  userLongitude: string;
  mainProduct: string;
  code: string;

	constructor( o ?: any) {
    this.id = o ? o.id : null;
    this.date = o ? o.date : null;
    this.dateFormated = '';
    this.dateHour = '';
    this.orderTypeDescription = o ? o.order_type_description : null;
    this.orderTypeId = o ? o.order_type_id : null;
    this.statusId = o ? o.status_id : null;
    this.clientId = o ? o.client_id : null;
    this.clientName = o ? o.client_name : null;
    this.total = o ? o.total : null;
    this.userName = o ? o.user_name : null;
    this.userLatitude = o ? o.user_latitude : null;
    this.userLongitude = o ? o.user_longitude : null;
    this.mainProduct = o ? o.principal_product : null;
    this.code = o ? o.code : null;
  }
  
  mapOrder(list: any[]): Order[] {
    let newList: Order[] = [];
    list.forEach((item: any) => {
      let newItem: Order = new Order(item);
      newList.push(newItem);
    });
    return newList;
  }

}
